module.exports = __webpack_public_path__ + "media/country_flags/yt-a8995286.png";